import PropTypes from 'prop-types';

const ActionsIcon = () => {
  return null;
};

ActionsIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ActionsIcon;
